// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__31IAH","insightsList":"newBusinessInsightsMenu_insightsList__1zk2V","active":"newBusinessInsightsMenu_active__3sHmu"};